import PropTypes from 'prop-types';
import React from 'react';

const Icon = ({ width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 14 14"
  >
    <title>Link Out</title>
    <path
      fill="currentColor"
      d="M5.646 7.146a.5.5 0 10.708.708l-.708-.708zM13.5.5A.5.5 0 0013 0H8.5a.5.5 0 000 1h4v4a.5.5 0 001 0V.5zM6.354 7.854l7-7-.708-.708-7 7 .708.708z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.75 1.5H2a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2V6.75h-1v4.75a1 1 0 01-1 1H2a1 1 0 01-1-1v-8a1 1 0 011-1h4.75v-1z"
      clipRule="evenodd"
    />
  </svg>
);

Icon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Icon.defaultProps = {
  width: 14,
  height: 14,
};

export default Icon;
